<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 id="_idParaDest-2"><a id="_idTextAnchor001"></a>Acknowledgments</h2>
<p class="veryfirst">As the saying goes, “The teacher is always the primary learner.” This has been especially true as we have made our way through these books of the Bible and through these many writers of the Reformation. Our learning from this project will undoubtedly continue to bear personal and professional fruit in us for years to come. We hope that readers’ engagement with this volume will likewise lead to new insights and a renewed love of and appreciation for God’s Word.</p>
<p class="body">We are grateful to InterVarsity Press for the opportunity to contribute to this great series, the Reformation Commentary on Scripture. We would especially like to express our gratitude to Timothy George, Scott Manetsch, Joel Scandrett, Michael Gibson, Brannon Ellis, David McNutt, Frank James, David Lamb, Todd Hains and David Hooper.</p>
<p class="body">We are also immensely thankful to our families for their love and support over the several years, busy weeks, early mornings and long nights a project like this requires. To Barb, Gabriela, Eli and Mia Cooper; Carrie, Hilde, Jonah and Theodore Lohrmann: we thank God for you as companions in faith and in life.</p>
<p class="body">Finally, we wish to dedicate this volume to the Rev. Dr. Timothy J. Wengert, who served as <i>Doktorvater</i> for both of us in our studies at The Lutheran Theological Seminary at Philadelphia. Through his outstanding teaching and guidance, Dr. Wengert has shown us how good scholarship and firm faith can go hand in hand with service to the church and the wider society. We dedicate this book to him with deep admiration, appreciation and thanks.</p>
<p class="body">With all the faithful, we give thanks to God in the words of David: “The Lord is my rock and my fortress and my deliverer, my God, my rock, in whom I take refuge” (2 Sam 22:2-3).</p>
<p class="first"><i>Derek Cooper</i></p>
<p class="left"><i>Martin J. Lohrmann</i></p>
<p class="body"><span class="pagebreak" id="pagexiv" title="xiv"></span></p>
<p class="body"><span class="pagebreak" id="pagexv" title="xv"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?73b1ed26